import { render, staticRenderFns } from "./ModalDescribeSticker.vue?vue&type=template&id=0c2521c5&scoped=true&"
import script from "./ModalDescribeSticker.vue?vue&type=script&lang=js&"
export * from "./ModalDescribeSticker.vue?vue&type=script&lang=js&"
import style0 from "./ModalDescribeSticker.vue?vue&type=style&index=0&id=0c2521c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2521c5",
  null
  
)

export default component.exports